// Finds a key in the object, case insensitively. Ideal when accesssing surveys
const caseInsensitiveObjectSearch = (obj: { [key: string]: any }, key: string) => {
  const foundKey = Object.keys(obj).find((k) => k.toLowerCase() === key.toLowerCase());
  return foundKey ? obj[foundKey] : undefined;
};

export default caseInsensitiveObjectSearch;
